// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BT5C","largestCol":"styles_largestCol__3B7DT","smallestCol":"styles_smallestCol__3bksu"};